import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { BlocksDownloadComponent } from '@twisto/api-cms'

import { StoreButton, StrapiMedia } from 'homepage/components/atoms'
import { useHighlightedText } from 'homepage/libs/hooks'

import * as styles from './primary.styles'

export type PrimaryDownloadWidgetProps = BlocksDownloadComponent & {
  isExtendedAllowed?: boolean
}

export const PrimaryDownloadWidget = ({
  description,
  highlightedDescription,
  stores,
  src,
  extended,
  isExtendedAllowed = true,
}: PrimaryDownloadWidgetProps) => {
  const { before, after, highlight } = useHighlightedText(
    description,
    highlightedDescription
  )

  return (
    <div
      css={[styles.download, extended && isExtendedAllowed && styles.extended]}
    >
      <StrapiMedia {...src} />

      <div>
        <Typography fontWeight="heavy">
          {before}
          <span css={styles.highlighted}>{highlight}</span>
          {after}
        </Typography>

        {extended && isExtendedAllowed && (
          <div css={styles.stores}>
            {stores?.map(({ id, storeLogo, url }) => (
              <StoreButton key={id} storeLogo={storeLogo} url={url} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
